import * as React from 'react';

const mapBackgroundClass = 'bgr__map';
const lightMapBackgroundClass = 'bgr__map__light';

export function withMapBackground<P extends object>(Component: React.ComponentType<P>, isLight: boolean = false) {
    return class MapBackgroundEnhancer extends React.Component<P> {
        private mapBackgroundClass: string;

        constructor(props: any) {
            super(props);

            this.mapBackgroundClass = isLight ? lightMapBackgroundClass : mapBackgroundClass;
        }

        componentDidMount() {
            document.getElementsByTagName('body')[0].classList.add(this.mapBackgroundClass);
        }

        componentWillUnmount() {
            document.getElementsByTagName('body')[0].classList.remove(this.mapBackgroundClass);
        }

        render() {
            return <Component {...this.props} />;
        }
    };
}



// WEBPACK FOOTER //
// ./src/webportal/components/hocs/MapBackgroundEnhancer.tsx